import { format, formatDistanceToNowStrict, formatDuration, isToday, isValid, isYesterday, parseISO, } from "date-fns";
import { capitalizeFirstLetter } from "./common";
import { DATE_FIELD_FORMAT } from "./constants";
/** Get strict time difference between now and provided time
 *
 * @param isoTime Time in ISO format
 * @param [wholeDays] Optional - whether to only use whole days for differences
 */
export const getTimeDifference = (isoTime, wholeDays = false) => {
    const date = new Date(isoTime);
    if (wholeDays) {
        // there's really only issues displaying whole days within the first 24 hours,
        // so handle those and then use default display otherwise.
        if (isToday(date))
            return "Today";
        if (isYesterday(date))
            return "Yesterday";
    }
    const result = capitalizeFirstLetter(formatDistanceToNowStrict(date, { addSuffix: true }));
    if (result.toLowerCase().includes("second"))
        return "Seconds ago";
    else
        return result;
};
/** Converts seconds to days
 * @param seconds number of seconds
 */
export const convertSecondsToDays = (seconds) => {
    return Math.floor(seconds / 3600 / 24);
};
export function transformDuration(duration) {
    if (duration === 0)
        return "--";
    const seconds = duration % 60;
    const minutes = Math.floor(duration / 60) % 60;
    const hours = Math.floor(duration / 3600);
    const hoursString = hours ? `${hours}h ` : "";
    const minutesString = minutes ? `${minutes}min ` : "";
    const secondsString = seconds ? `${seconds}s` : "";
    return `${hoursString}${minutesString}${secondsString}`;
}
export function transformScanDuration(duration) {
    // scan_duration is `dd hh:mm:ss.sss`; the day prefix is optional.
    const [dayPart, timePart] = duration.includes(" ")
        ? duration.split(" ")
        : ["0", duration];
    const parts = timePart.split(":");
    const hours = parseInt(dayPart) * 24 + parseInt(parts[0]);
    const minutes = parseInt(parts[1]);
    const seconds = parseInt(parts[2]);
    if (hours === 0 && minutes === 0 && seconds === 0)
        return "<1 second";
    return formatDuration({
        hours,
        minutes,
        seconds,
    });
}
/**
 * Get a Date object from the passed ISO 8601 string. If invalid ISO string, returns null.
 * @param isoString ISO 8601 date-time string
 */
export function getDateFromISOString(isoString) {
    // using a try because when I tested parseISO with a number it throws, so being defensive (jmahoney)
    try {
        const parsedDate = parseISO(isoString);
        return isValid(parsedDate) ? parsedDate : null;
    }
    catch (_error) {
        return null;
    }
}
/**
 * Get the date string for displaying Release Date (versions).
 * It expects releaseDate to be in ISO 8601 format,
 *
 * @param releaseDate ISO 8601 formatted date string
 * @param dateFormat
 */
export function getReleaseDateDisplay(releaseDate, dateFormat = DATE_FIELD_FORMAT) {
    if (!releaseDate || !releaseDate.includes("T"))
        return null;
    // giving getDateFromISOString a date string without time
    // will effectively pin the date regardless of timezone.
    const dateOnly = getDateFromISOString(releaseDate.split("T")[0]);
    if (!dateOnly)
        return null;
    return format(dateOnly, dateFormat);
}
//# sourceMappingURL=dateAndTime.js.map